// Module
var code = "{{$parent.row.sources.length}}";
// Exports
module.exports = code;